import { useTranslation as useTranslation$1 } from 'react-i18next';
import { useSiteContext } from '@zooplus/commons-lang';

const PACKAGE_TRANSLATIONS_NAMESPACE_PREFIX = 'zootopia-components/locales';
// This tells i18n to use the namespace configured here o retrieve translations for the components
// We are using the i18next instance of the parent application!
// When your library is used inside a parent, then the parent must have configured the backend path to use content_cdn_url/media
// Configure this according your path pattern defined in content CDN.
// Take into account that the base URL to get translations configured in the application should be the CDN_URL/media
// Use this hook in your components so you don't need to define the ns for each of them
const useTranslation = () => {
    const { site } = useSiteContext();
    return useTranslation$1(`${PACKAGE_TRANSLATIONS_NAMESPACE_PREFIX}/${site.realm}/samples-component`);
};

export { PACKAGE_TRANSLATIONS_NAMESPACE_PREFIX, useTranslation };
//# sourceMappingURL=use-translations.js.map
